import Axios from 'axios';
import Env from '../lib/Env'

export class PlatformClient {
    constructor() {
        
        this.http = Axios.create({
            baseURL: Env.get('API_HOST'),
            timeout: 30000,
            responseType: 'json'
          });
          
        this.http.defaults.withCredentials = true
    }
}

export class TransactionsClient {
    constructor() {
        this.http = Axios.create({
            baseURL: Env.get('TRANSACTION_API'),
            timeout: 30000,
            responseType: 'json'
          });
          
        this.http.defaults.withCredentials = true
    }
}

export class MediaClient {
    constructor() {
        this.http = Axios.create({
            baseURL: Env.get('INTEGRATION_API'),
            timeout: 30000,
            responseType: 'json'
          });
          
        this.http.defaults.withCredentials = true
    }
}

export class SandboxClient {
    constructor() {
        this.http = Axios.create({
            baseURL:Env.get('SANDBOX_HOST'),
            timeout: 30000,
            responseType: 'json'
          });
          
        this.http.defaults.withCredentials = true
    }
}